module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-1-Article-w720.41be5e71.jpg";